// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilo geral da página */
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #3f4147; /* Fundo escuro */
  color: #ffffff; /* Texto claro */
}

/* Contêiner principal */
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh; /* Altura total da tela */
  padding: 0 10px; /* Espaço lateral */
  background-color: #3f4147; /* Fundo escuro */
  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */
}

/* Caixa de login */
.login-box {
  width: 100%;
  max-width: 400px; /* Limite em telas maiores */
  background-color: #ffffff; /* Fundo branco */
  color: #3f4147; /* Texto escuro */
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */
}

/* Logo */
.login-logo {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.login-logo img {
  max-width: 150px; /* Tamanho padrão */
  height: auto;
}

@media (min-width: 768px) {
  .login-logo img {
    max-width: 200px; /* Aumenta o tamanho da logo em telas maiores */
  }
}

/* Título */
.login-box h1 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #3f4147;
}

/* Formulário */
.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #3f4147; /* Texto escuro */
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */
}

/* Botão */
button {
  width: 100%; /* Ocupa toda a largura */
  padding: 10px;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: bold;
}

button:hover {
  background-color: #0056b3;
}

/* Mensagem de erro */
.error-message {
  color: #f44336;
  font-size: 14px;
  margin-top: -10px;
  margin-bottom: 10px;
  text-align: center;
}

/* Modal de Esqueci Minha Senha */
.forgot-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.forgot-modal-content {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
}

.forgot-modal-content h2 {
  margin-top: 0;
  text-align: center;
  color: #333;
}

.forgot-modal .form-group {
  margin-bottom: 15px;
}

.forgot-password-button {
  background-color: transparent;
  color: #007bff;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  margin-top: 10px;
}

.forgot-password-button:hover {
  color: #0056b3;
}

/* Botões do modal */
.button-group {
  display: flex;
  flex-direction: column; /* Botões empilhados */
  gap: 10px;
  margin-top: 20px;
}

.save-button,
.cancel-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.save-button {
  background-color: #007bff;
  color: #ffffff;
  transition: background-color 0.3s;
}

.save-button:hover {
  background-color: #0056b3;
}

.cancel-button {
  background-color: #dc3545;
  color: #ffffff;
  transition: background-color 0.3s;
}

.cancel-button:hover {
  background-color: #c82333;
}

.success-message {
  color: #4caf50;
  font-weight: bold;
  margin: 10px 0;
}

.error-message {
  color: #f44336;
  font-weight: bold;
  margin: 10px 0;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  cursor: pointer;
  margin-top: 10px;
}

button:hover {
  background-color: #0056b3;
}

/* Responsividade */
@media (max-width: 768px) {
  .login-box {
    border-radius: 0; /* Remove bordas arredondadas */
    box-shadow: none; /* Remove sombra */
    padding: 20px; /* Ajusta o espaçamento interno */
    background-color: #3f4147; /* Fundo escuro no mobile */
    color: #ffffff; /* Texto claro */
  }

  .login-box h1 {
    color: white; /* Ajusta cor do título */
  }

  .form-group label {
    color: white; /* Ajusta cor dos rótulos */
  }

  .form-group input {
    background-color: #ffffff;
    color: #333;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,SAAS;EACT,8BAA8B;EAC9B,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,gBAAgB;AAClC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB,EAAE,yBAAyB;EAC5C,eAAe,EAAE,mBAAmB;EACpC,yBAAyB,EAAE,iBAAiB;EAC5C,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB,EAAE,4BAA4B;EAC9C,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc,EAAE,iBAAiB;EACjC,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB,EAAE,mBAAmB;EACrC,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB,EAAE,+CAA+C;EACnE;AACF;;AAEA,WAAW;AACX;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc,EAAE,iBAAiB;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,UAAU;AACV;EACE,WAAW,EAAE,yBAAyB;EACtC,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB,EAAE,sBAAsB;EAC9C,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB,EAAE,+BAA+B;IACjD,gBAAgB,EAAE,kBAAkB;IACpC,aAAa,EAAE,iCAAiC;IAChD,yBAAyB,EAAE,2BAA2B;IACtD,cAAc,EAAE,gBAAgB;EAClC;;EAEA;IACE,YAAY,EAAE,yBAAyB;EACzC;;EAEA;IACE,YAAY,EAAE,2BAA2B;EAC3C;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;AACF","sourcesContent":["/* Estilo geral da página */\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n  background-color: #3f4147; /* Fundo escuro */\n  color: #ffffff; /* Texto claro */\n}\n\n/* Contêiner principal */\n.login-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh; /* Altura total da tela */\n  padding: 0 10px; /* Espaço lateral */\n  background-color: #3f4147; /* Fundo escuro */\n  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */\n}\n\n/* Caixa de login */\n.login-box {\n  width: 100%;\n  max-width: 400px; /* Limite em telas maiores */\n  background-color: #ffffff; /* Fundo branco */\n  color: #3f4147; /* Texto escuro */\n  border-radius: 8px;\n  padding: 30px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */\n}\n\n/* Logo */\n.login-logo {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.login-logo img {\n  max-width: 150px; /* Tamanho padrão */\n  height: auto;\n}\n\n@media (min-width: 768px) {\n  .login-logo img {\n    max-width: 200px; /* Aumenta o tamanho da logo em telas maiores */\n  }\n}\n\n/* Título */\n.login-box h1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #3f4147;\n}\n\n/* Formulário */\n.form-group {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.form-group label {\n  display: block;\n  font-size: 14px;\n  color: #3f4147; /* Texto escuro */\n  margin-bottom: 5px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box; /* Inclui padding no cálculo do tamanho */\n}\n\n/* Botão */\nbutton {\n  width: 100%; /* Ocupa toda a largura */\n  padding: 10px;\n  background-color: #007bff;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-weight: bold;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n/* Mensagem de erro */\n.error-message {\n  color: #f44336;\n  font-size: 14px;\n  margin-top: -10px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n/* Modal de Esqueci Minha Senha */\n.forgot-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.forgot-modal-content {\n  background-color: #ffffff;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n}\n\n.forgot-modal-content h2 {\n  margin-top: 0;\n  text-align: center;\n  color: #333;\n}\n\n.forgot-modal .form-group {\n  margin-bottom: 15px;\n}\n\n.forgot-password-button {\n  background-color: transparent;\n  color: #007bff;\n  border: none;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.forgot-password-button:hover {\n  color: #0056b3;\n}\n\n/* Botões do modal */\n.button-group {\n  display: flex;\n  flex-direction: column; /* Botões empilhados */\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.save-button,\n.cancel-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.save-button {\n  background-color: #007bff;\n  color: #ffffff;\n  transition: background-color 0.3s;\n}\n\n.save-button:hover {\n  background-color: #0056b3;\n}\n\n.cancel-button {\n  background-color: #dc3545;\n  color: #ffffff;\n  transition: background-color 0.3s;\n}\n\n.cancel-button:hover {\n  background-color: #c82333;\n}\n\n.success-message {\n  color: #4caf50;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.error-message {\n  color: #f44336;\n  font-weight: bold;\n  margin: 10px 0;\n}\n\nbutton {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 15px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .login-box {\n    border-radius: 0; /* Remove bordas arredondadas */\n    box-shadow: none; /* Remove sombra */\n    padding: 20px; /* Ajusta o espaçamento interno */\n    background-color: #3f4147; /* Fundo escuro no mobile */\n    color: #ffffff; /* Texto claro */\n  }\n\n  .login-box h1 {\n    color: white; /* Ajusta cor do título */\n  }\n\n  .form-group label {\n    color: white; /* Ajusta cor dos rótulos */\n  }\n\n  .form-group input {\n    background-color: #ffffff;\n    color: #333;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
